var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "#0A4FAC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#0A4FAC",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M20.5,-38.1C24.8,-33,25.4,-24,28,-17C30.7,-10,35.5,-5,37.3,1C39.1,7.1,38,14.2,35.1,20.9C32.3,27.6,27.8,34,21.7,36.4C15.5,38.9,7.8,37.4,1,35.6C-5.7,33.9,-11.4,31.7,-18.4,29.8C-25.3,27.8,-33.5,25.9,-36,21C-38.5,16.1,-35.3,8,-35.4,-0.1C-35.6,-8.2,-39.1,-16.4,-37.9,-23.5C-36.7,-30.7,-30.7,-36.8,-23.6,-40.3C-16.5,-43.8,-8.2,-44.8,-0.1,-44.7C8.1,-44.5,16.2,-43.3,20.5,-38.1Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.ba3dac4bbd7c292378df86bfd4cf07f1.svg";
export { ForwardRef as ReactComponent };